import FormDataAPIContent from "../../../../src/pages/pricing/contact/sales/form-data-api/form-data-api-content.md";
import { FormDataAPI } from "../../../../src/components/form-data-api";
import * as React from 'react';
export default {
  FormDataAPIContent,
  FormDataAPI,
  React
};